import CIcon from '@coreui/icons-react';
import { CLink } from '@coreui/react';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { setFlexibleMultiModal } from '../../../../../../../actions/common';
import { COMPONENT_NAME } from '../../../../../../../constants';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const ViewReviewAnalyse = ({ insight, ruleId, index, models }) => {
    const runDate = insight?.runAt ? dayjs.utc(insight.runAt).format('MMM D, YYYY') : 'N/A';
    const enableShowCost = localStorage.getItem('show-llm-costs') || window.location.search.includes('show-llm-costs=1');

    const dispatch = useDispatch();
    const intelligenceSetting = useSelector((state) => state.subscriber.intelligenceSetting);

    const handleViewPrompt = () => {
        dispatch(
            setFlexibleMultiModal({
                show: true,
                component: COMPONENT_NAME.INTENT_ANALYSIS_REVIEW_INTENT_RULES_PROMPT,
                attributes: { insight, ruleId, models },
            })
        );
    };

    return (
        <div key={index} className="row-rule d-flex justify-content-between">
            <div className="info-wrap d-flex justify-content-between align-items-center py-2">
                <div className="info-title">
                    <h4 style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="mr-3">{runDate}</span>
                    </h4>
                </div>
            </div>

            <div className="options-wrapper d-flex">
                {enableShowCost && (
                    <div className="option-item hover-show-tooltip">
                        <CLink className="option text-primary">
                            <CIcon height={14} icon="icon-info" className="icon-primary" />
                        </CLink>

                        <div className="block-tooltip">
                            <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />
                            <div className="block-tooltip-text text-start font-size-12">
                                <p>Tokens In: {Number(insight.inputTokens).toLocaleString('en-US')}</p>
                                <p>Tokens Out: {Number(insight.outputTokens).toLocaleString('en-US')}</p>
                                <p>Total Tokens: {(Number(insight.inputTokens) + Number(insight.outputTokens)).toLocaleString('en-US')}</p>
                                <p>Total cost for analysis: {Number(insight.totalCost)}$</p>
                            </div>
                        </div>
                    </div>
                )}

                {
                    insight.chargedCredits > 0 && intelligenceSetting?.aiBillingCycle && (
                        <div className="option-item hover-show-tooltip">
                            <CLink className="option text-primary">
                                <CIcon icon="iconDollarSign" className="icon-primary" />
                            </CLink>

                            <div className="block-tooltip">
                                <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />
                                <div className="block-tooltip-text text-start font-size-12">
                                    <p>AI Credits Used: {insight.chargedCredits}</p>
                                </div>
                            </div>
                        </div>
                    )
                }

                <div className="option-item hover-show-tooltip">
                    <CLink className="option text-primary" onClick={handleViewPrompt}>
                        <CIcon icon="icon-eye" height={14} />
                    </CLink>

                    <div className="block-tooltip">
                        <CIcon icon="arrowTooltip" className="arrow-tooltip-preview" />

                        <div className="block-tooltip-text font-size-12">
                            <p>View Intent</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewReviewAnalyse;
